export default {
    label: 'Zadejte registrační značku a vyberte si běžný servis, svolávací akci, partnera pro výměnu pneumatik nebo nejbližší dobíjecí stanici.',
    description: 'Abychom vás mohli identifikovat, potřebujeme nezbytně znát RZ vašeho vozu.',

    submitButton: 'Pokračovat',
    logoutButton: 'Zpět na úvod',

    validationLicensePlate: 'Prosíme zadejte RZ vozidla.',
    validationRecaptcha: 'Prosíme potvrďte, že nejste robot.',

    infoMessageLogout: 'Byl jste úspěšně odhlášen.',
    successMessageLogin: 'Přihlášení proběhlo úspěšně, můžete si vybrat servis.',
    errorNoMaintenance: 'Službu údržba s námi nemáte sjednanou.',
    errorMessageLogin: 'Je nám líto, ale na toto vozidlo není možné vytvořit požadavek na objednání do servisu. Prosím, zkontrolujte zadanou RZ a zkuste to znovu. Pokud potřebujete poradit, obraťte se na nás na lince +420 296 333 666.'
}
